import { call, put, takeLatest } from "redux-saga/effects";
import services from "../../services";

import {
  GET_ALL_COURSES,
  GET_ALL_COURSES_SUCCESS,
  GET_ALL_COURSES_ERROR,
  RESET_GET_ALL_COURSES,
  initialState as allCoursesInitialState
} from "../types/course/get-all.dto";

import {
  GET_ONE_COURSE,
  GET_ONE_COURSE_SUCCESS,
  GET_ONE_COURSE_ERROR,
  RESET_GET_ONE_COURSE,
  initialState as oneCourseInitialState
} from "../types/course/get-one.dto";

function* getAllCourse({ payload }) {
  try {
    const { response, error } = yield call(services.course.getAll, payload);

    if (error) {
      yield put({ type: GET_ALL_COURSES_ERROR, payload: error });
    } else {
      try {
        yield put({
          type: GET_ALL_COURSES_SUCCESS,
          payload: response,
        });
      } catch (error) {
        console.log('GET_ALL_COURSES_SUCCESS', error)
      }
    }
  } catch (error) {
    yield put({
      type: GET_ALL_COURSES_ERROR,
      payload: "Error al obtener cursos",
    });
  }
}

function* getOneCourse({ payload }) {
  try {
    const { response, error } = yield call(services.course.getOne, payload);
    if (error) {
      yield put({ type: GET_ONE_COURSE_ERROR, payload: error });
    } else {
      try {
        console.log('saga GET_ONE_COURSE')
        yield put({
          type: GET_ONE_COURSE_SUCCESS,
          payload: response,
        });
      } catch (error) {
        console.log('GET_ONE_COURSE_SUCCESS', error)
      }
    }
  } catch (error) {
    yield put({
      type: GET_ONE_COURSE_ERROR,
      payload: "Error al obtener un curso",
    });
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<any>(GET_ALL_COURSES, getAllCourse);
  yield takeLatest<any>(GET_ONE_COURSE, getOneCourse);
}
